module.exports = __webpack_public_path__ + "img/TermsConditions.223e9e6a.svg";